module.exports = __webpack_public_path__ + "img/payment-success-illustration.561e2df2.svg";